<template>
  <v-card outlined class="elevation-0 mx-4">
    <v-data-table
      :headers="headers"
      :items="classrooms"
      :loading="loading"
      class="elevation-0 mt-0"
      :footer-props="{
        itemsPerPageText: 'Số dòng mỗi trang:',
      }"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon class="mr-2" @click="$emit('edit', item)"> mdi-pencil </v-icon>
        <v-icon @click="$emit('delete', item)"> mdi-delete </v-icon>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  name: 'ClassroomTable',
  props: {
    headers: {
      type: Array,
      required: true,
    },
    classrooms: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.v-data-table {
  margin-top: 20px;
}
</style>
